import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "p-3 position-relative",
  id: "visit-attachments-upload-hc"
}
const _hoisted_2 = { class: "position-absolute top-0 end-0 pt-2 pe-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h6", { class: "text-center fw-bold" }, "File Attachment:", -1 /* HOISTED */)
const _hoisted_4 = { class: "w-100 mb-3" }
const _hoisted_5 = { class: "custom-file" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "upload-document",
  class: "custom-file-label upload-file-name"
}, "Choose File", -1 /* HOISTED */)
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_9 = { class: "me-0" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-paperclip new-paperclip" }, null, -1 /* HOISTED */)
const _hoisted_11 = { class: "ms-1" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1 /* HOISTED */)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = {
  key: 0,
  class: "d-none"
}
const _hoisted_15 = {
  key: 0,
  class: "form-check align-items-center px-0"
}
const _hoisted_16 = ["id", "value", "checked", "onClick"]
const _hoisted_17 = ["for"]
const _hoisted_18 = { class: "me-1" }
const _hoisted_19 = { class: "d-flex justify-content-center mt-2 p-2" }
const _hoisted_20 = { key: 0 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-primary",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-spinner fa-spin animated slow flash infinite" })
], -1 /* HOISTED */)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn-close",
        "aria-label": "close",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel()))
      })
    ]),
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("input", {
          type: "file",
          name: "Attachment",
          ref: "file1",
          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFilesChanged($event))),
          disabled: _ctx.isSaving,
          id: "upload-document",
          class: "custom-file-input valid"
        }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_7)
      ]),
      (_ctx.attachment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("a", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.attachment.name), 1 /* TEXT */)
            ]),
            _createElementVNode("button", {
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.removeAttachedFile())),
              class: "btn table-btn btn-outline-danger"
            }, _hoisted_13)
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploadedDocumentationType, ([, information]) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: information.name
      }, [
        (information.value === _ctx.uploadedDocumentationTypeEnum.None || !_ctx.showDocumentTypes)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.displayDocumentType(information.value))
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("input", {
                      type: "radio",
                      class: "me-1",
                      name: "UploadedDocumentationType",
                      id: `uploadedDocumentationType_${information.name}`,
                      value: information.value,
                      checked: _ctx.documentType === information.value,
                      onClick: ($event: any) => (_ctx.documentTypeChanged(information.value))
                    }, null, 8 /* PROPS */, _hoisted_16),
                    _createElementVNode("label", {
                      for: `uploadedDocumentationType_${information.name}`
                    }, [
                      _createElementVNode("span", _hoisted_18, _toDisplayString(information.longDescription), 1 /* TEXT */)
                    ], 8 /* PROPS */, _hoisted_17)
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("div", _hoisted_19, [
      (_ctx.isSaving)
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, _hoisted_22))
        : (_openBlock(), _createElementBlock("span", _hoisted_23, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.saveAttachment()))
            }, "Save")
          ]))
    ])
  ]))
}